module.exports = __webpack_public_path__ + "img/gys_23@2x.29231f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_23@2x.png
// module id = +Gte
// module chunks = 0